import { useGlobalContextActions } from '../index';

export const useIsNewNavigation = () => {
	const { getHorizontalNav } = useGlobalContextActions();

	return getHorizontalNav?.() || false;
};
